import React from 'react';
import { Result } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { isEmpty as _isEmpty } from 'lodash';
import NoInsights from 'assets/images/empty-folder.png';
import AccessDenied from 'assets/images/accessDenied.png';
import ErrorInInsights from 'assets/images/no-data-found.svg';
import ComingSoonImage from 'assets/images/coming-soon.png';
import Empty from 'assets/images/empty.svg';
import './SMResult.scss';

const SMResult = props => {
  const {
    type,
    message,
    subMessage,
    size,
    component,
    forChart,
    noMargin = false,
    customImage = '',
    messageClassNames = '',
    subMessageClassName = ''
  } = props;

  if (!_isEmpty(type)) {
    // --- Loader type :: apiFailure
    if (type === 'apiFailure') {
      return (
        <div className={`c-notifiContainer ${size ? size : ''} ${forChart ? 'forChart' : ''} ${noMargin ? 'm0' : ''}`}>
          <Result
            icon={<img src={!_isEmpty(customImage) ? customImage : Empty} alt='error' className='notifi_icon' />}
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            {...props}
          />
          <div style={{ marginTop: '24px' }}>{!_isEmpty(component) && component}</div>
        </div>
      );
    }

    // --- Loader type :: Loading
    if (type === 'loader') {
      return (
        <div className={`c-notifiContainer ${size ? size : ''} ${forChart ? 'forChart' : ''} ${noMargin ? 'm0' : ''}`}>
          <Result
            icon={<Loading3QuartersOutlined className='notifi_spinner' spin />}
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            subTitle={
              !_isEmpty(subMessage) && (
                <span className={_isEmpty(subMessageClassName) ? `notifi_message` : subMessageClassName}>
                  {subMessage}
                </span>
              )
            }
            {...props}
          />
        </div>
      );
    }

    // --- Loader type :: Blank / Empty data
    if (type === 'empty') {
      return (
        <div
          className={`c-notifiContainer container-type-empty ${size ? size : ''} ${forChart ? 'forChart' : ''} ${
            noMargin ? 'm0' : ''
          }`}
        >
          <Result
            icon={
              <img
                src={!_isEmpty(customImage) ? customImage : NoInsights}
                alt='empty'
                className={`notifi_icon ${!_isEmpty(customImage) ? 'mb-2' : ''}`}
              />
            }
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            subTitle={
              !_isEmpty(subMessage) && (
                <span className={_isEmpty(subMessageClassName) ? `notifi_message` : subMessageClassName}>
                  {subMessage}
                </span>
              )
            }
            {...props}
          />
          <div style={{ marginTop: '16px' }}>{!_isEmpty(component) && component}</div>
        </div>
      );
    }

    // --- Loader type :: Access denied
    if (type === 'accessDenied') {
      return (
        <div className={`c-notifiContainer ${size ? size : ''} ${forChart ? 'forChart' : ''} ${noMargin ? 'm0' : ''}`}>
          <Result
            icon={
              <img
                src={!_isEmpty(customImage) ? customImage : AccessDenied}
                alt='Coming Soon'
                className='notifi_icon lg'
              />
            }
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            subTitle={
              !_isEmpty(subMessage) && (
                <span className={_isEmpty(subMessageClassName) ? `notifi_message` : subMessageClassName}>
                  {subMessage}
                </span>
              )
            }
            {...props}
          />
          {!_isEmpty(component) && component}
        </div>
      );
    }

    // --- Loader type :: error
    if (type === 'error') {
      return (
        <div className={`c-notifiContainer ${size ? size : ''} ${forChart ? 'forChart' : ''} ${noMargin ? 'm0' : ''}`}>
          <Result
            icon={
              <img src={!_isEmpty(customImage) ? customImage : ErrorInInsights} alt='error' className='notifi_icon' />
            }
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            {...props}
          />
          <div style={{ marginTop: '24px' }}>{!_isEmpty(component) && component}</div>
        </div>
      );
    }

    // --- Loader type :: error
    if (type === 'coming_soon') {
      return (
        <div className={`c-notifiContainer ${size ? size : ''} ${forChart ? 'forChart' : ''} ${noMargin ? 'm0' : ''}`}>
          <Result
            icon={
              <img
                src={!_isEmpty(customImage) ? customImage : ComingSoonImage}
                alt='Coming Soon'
                className='notifi_icon lg'
              />
            }
            title={
              !_isEmpty(message) && (
                <span className={_isEmpty(messageClassNames) ? `notifi_message` : messageClassNames}>{message}</span>
              )
            }
            {...props}
          />
          {!_isEmpty(component) && component}
        </div>
      );
    }
  }

  //   --- Else Return Spinner
  return <Result icon={<Loading3QuartersOutlined className='spinner' spin />} />;
};

export default SMResult;
